import { faArrowLeft, faRefresh, faTrash, faTrashRestore, faUser } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetchData } from 'hooks/apiHooks';

export function useComponentDetails(endpoint, list, toggleReports, initShowAgent=true) {
    const { data, setData, saveData, setAndSave, setAndSaveUniqueFlag, saveKey: rawSaveKey, isLoading, error, saveError, success, refetch } = useFetchData(endpoint, null, true);
    const navigate = useNavigate();
    const [showAIAgent, setShowAIAgent] = useState(initShowAgent); 

    const saveKey = async (key, value) => {
        rawSaveKey(key, value);
        const elementInList = list?.list?.items?.find(item => item.id === data.id)

        if (elementInList && key in elementInList) {
            list.setLineKey(data?.id, key, value);
        }
    };

    const handleDelete = () => {
        if(list){
            list.toggleDelete(data.id)
        }
        else {
            saveKey('is_deleted', !data?.is_deleted)
        }
        navigate(-1);
    }

    const goBack = () => { navigate(-1); }

    const toolbar = {
        closeReports: { translationId: `toolbar.back`, icon: faArrowLeft, onClick: toggleReports, visible: true },
        back: { translationId: `toolbar.back`, icon: faArrowLeft, onClick: goBack, visible: true },
        refresh: { translationId: `toolbar.refresh`, icon: faRefresh, onClick: refetch, visible: true },
        delete: { translationId: `toolbar.delete`, icon: faTrash, onClick: handleDelete, visible: !data?.is_deleted },
        undelete: { translationId: `toolbar.undelete`, icon: faTrashRestore, onClick: handleDelete, visible: data?.is_deleted },
        toggleAIPanel: { translationId: showAIAgent ? 'toolbar.hideAIAgent' : 'toolbar.showAIAgent', icon: faUser, onClick: () => setShowAIAgent(!showAIAgent), visible: true }
    }

    return { 
        data, setData, saveData, setAndSave, setAndSaveUniqueFlag, saveKey, isLoading, error, saveError, success, refetch,
        handleDelete,
        showAIAgent, 
        setShowAIAgent,
        toolbar
    }
  }